import {
  getOrganizationBrand,
  getBrandStat,
  updateOrganizationBrand,
  removeLogo,
  uploadLogoFile,
} from '../thunks/organization-brand';

export const organizationBrandsReducers = (builder) => {
  builder
    .addCase(getOrganizationBrand.fulfilled, (state, action) => {
      const brand = action.payload;
      state.brand.value = brand;
      state.brand.loading = false;
    })
    .addCase(getOrganizationBrand.pending, (state) => {
      state.brand.loading = true;
    })
    .addCase(getOrganizationBrand.rejected, (state) => {
      state.brand.loading = false;
    });

  builder
    .addCase(getBrandStat.fulfilled, (state, action) => {
      const stat = action.payload;
      state.brandStat.value = stat;
      state.brandStat.loading = false;
    })
    .addCase(getBrandStat.pending, (state) => {
      state.brandStat.loading = true;
    })
    .addCase(getBrandStat.rejected, (state) => {
      state.brandStat.loading = false;
    });

  builder
    .addCase(updateOrganizationBrand.fulfilled, (state, action) => {
      const brand = action.payload;
      state.brand.value = {
        ...brand,
        admins: state.brand.value.admins,
      };
      state.brand.updating = false;
    })
    .addCase(updateOrganizationBrand.pending, (state) => {
      state.brand.updating = true;
    })
    .addCase(updateOrganizationBrand.rejected, (state) => {
      state.brand.updating = false;
    });

  builder.addCase(uploadLogoFile.fulfilled, (state, action) => {
    const { id, logoId, type } = action.payload;
    if (type === 'organization') {
      state.brand.value = {
        ...state.brand.value,
        logo_file_id: logoId,
      };
    } else if (type === 'group') {
      state.selectedGroup.value = {
        ...state.selectedGroup.value,
        logo_file_id: logoId,
      };
      const brandGroups = state.brandGroups.value;
      const brandGroupIndex = brandGroups.findIndex((group) => group.id === id);
      brandGroups[brandGroupIndex] = {
        ...brandGroups[brandGroupIndex],
        logo_file_id: logoId,
      };
      state.brandGroups.value = [...brandGroups];
    }
  });

  builder.addCase(removeLogo.fulfilled, (state, action) => {
    const { id, type } = action.payload;
    if (type === 'organization') {
      state.brand.value = {
        ...state.brand.value,
        logo_file_id: '',
      };
    } else if (type === 'group') {
      state.selectedGroup.value = {
        ...state.selectedGroup.value,
        logo_file_id: '',
      };
      const brandGroups = state.brandGroups.value;
      const brandGroupIndex = brandGroups.findIndex((group) => group.id === id);
      brandGroups[brandGroupIndex] = {
        ...brandGroups[brandGroupIndex],
        logo_file_id: '',
      };
      state.brandGroups.value = [...brandGroups];
    }
  });
};
